import { Observable, Subscription, interval } from 'rxjs';
import { RealtimeService } from './../../../services/realtime.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ViewSession } from './models/view-session.model';
import { ViewSessionEvent } from './models/view-session-event.model';
import { Viewer } from './models/viewer.model';

@Component({
	selector: 'realtime-audience-view-sessions',
	templateUrl: './realtime-audience-view-sessions.component.html',
	styleUrls: ['./realtime-audience-view-sessions.component.scss']
})

export class RealtimeViewSessionsComponent implements OnInit, OnDestroy {

	viewSessions: ViewSession[];
	_filteredViewers: Viewer[];
	viewers: Viewer[];
	loading: boolean;
	events: ViewSessionEvent[];
	calculationObs: Observable<number>;
	detailLevel: number;
	nrToShow: number;
	isRoot = false;

	private subViewerAdded: Subscription;
	private subViewerRemoved: Subscription;
	private subInitialCallFinished: Subscription;
	private subLostFocus: Subscription;
	private _interval: Subscription;
	private _maxLiveViewtime: number;

	constructor(protected realtimeService: RealtimeService) {
		// this.detailLevel = 1;
		this.nrToShow = 12;
		this.events = [];
		this.viewSessions = [];
		this.viewers = [];
		this._filteredViewers = [];
		this._maxLiveViewtime = 0;
	}

	ngOnInit() {
		this.loading = true;
		this.subInitialCallFinished = this.realtimeService.initialCallFinished.subscribe((finished) => {
			this.loading = !finished;
			this._updateViewers();
			if (!this._interval) {
				this._interval = interval(5000).subscribe(() => {
					this._updateViewers();
				});
			}
		});
		// let sub = this.realtimeService.realTimeEvents().subscribe( (event) => this.handleEvent(event));
		this.subscribeViewers();

		this.subLostFocus = this.realtimeService.lostFocus.subscribe((lostFocus: boolean) => {
			if (lostFocus) {
				if (this._interval) {
					this._interval.unsubscribe();
					this._interval = null;
					this._updateViewers();
				}
				if (this.subViewerAdded) {
					this.subViewerAdded.unsubscribe();
					this.subViewerAdded = null;
				}
				this.nrToShow = 12;
				this.events = [];
				this.viewSessions = [];
				this.viewers = [];
				this._filteredViewers = [];
			} else {
				this.subscribeViewers();
			}
		});
	}

	subscribeViewers() {
		if (!this.subViewerAdded) {
			this.subViewerAdded = this.realtimeService.viewerAdded.subscribe((viewer: Viewer) => {
				if (!viewer.reActivated) {
					this.viewers.push(viewer);
					if (!viewer.fromBacklog) {
						viewer.justAdded = true;
					}
				}
				// console.warn('viewerAdded uid = ', viewer.uid, viewer);
			});
		}
	}

	_updateViewers(): void {
		const now = Date.now();
		// console.warn('filteredViewers / viewers ', this._filteredViewers.length, this.viewers.length);
		this._removeViewers();

		this._filteredViewers = this.viewers
			.filter((viewer) => {
				if (viewer && viewer.justAdded) {
					setTimeout(() => {
						viewer.justAdded = false;
					}, 1);
				}
				if (viewer && viewer.totalViewTime > this._maxLiveViewtime) {
					const max = 60 * 60 * 3; // 3 hours
					this._maxLiveViewtime = viewer.totalViewTime > max ? max : viewer.totalViewTime;
				}
				// console.warn('now - viewer.lastSighting.getTime() < 1000 * 60 * 60 )', now - viewer.lastSighting.getTime() );
				return viewer.pinned || ( // (this.nrToShow > this.viewers.length) ||
					(viewer.lastSighting && now - viewer.lastSighting.getTime() < 1000 * 60) &&
					!viewer.isRemoved &&
					viewer.activeSession &&
					viewer.activeSession.currentMediaclip &&
					viewer.activeSession.currentMediaclip.id &&
					viewer.activeSession.currentMediaclip.title);
			})
			.sort((a: Viewer, b: Viewer) => {
				// sort to show newest sessions first
				if (a.pinned && !b.pinned) {
					return -1;
				} else if (b.pinned && !a.pinned) {
					return 1;
				} else {
					return 0;
				}
			});
	}

	get filteredViewers(): Viewer[] {
		return this._filteredViewers;
		// .sort((a: Viewer, b: Viewer) => {
		// 	// sort to show newest sessions first
		// 	if (! b.firstSighting || ! a.firstSighting) {
		// 		return 1;
		// 	} else {
		// 		return b.firstSighting.getTime() - a.firstSighting.getTime();
		// 	}

		// });
	}

	getThumbUrl(id: string, width?: number, height?: number, publication?: string): string {
		const url = '//' + publication + '.bbvms.com/mediaclip/' + id + '/pthumbnail/' + width + '/' + height + '.jpg';
		return url;
	}

	sessionClicked(viewer: Viewer) {
		viewer.pinned = !viewer.pinned;
		this._updateViewers();
	}

	log() {
		if (arguments[0] && arguments[0].length) {
			console.warn(arguments[0].filter((o: Viewer) => o.activeSession && o.activeSession.currentMediaclip &&
				o.activeSession.currentMediaclip.id && !Number(o.activeSession.currentMediaclip.id)));
		} else {
			console.warn(arguments);
		}
	}

	ngOnDestroy() {
		if (this._interval) {
			this._interval.unsubscribe();
		}
		if (this.subViewerAdded) {
			this.subViewerAdded.unsubscribe();
		}
		if (this.subViewerRemoved) {
			this.subViewerRemoved.unsubscribe();
		}
		if (this.subInitialCallFinished) {
			this.subInitialCallFinished.unsubscribe();
		}
		if (this.subLostFocus) {
			this.subLostFocus.unsubscribe();
		}
	}

	private _removeViewers() {
		let i = this.viewers.length;
		while (i--) {
			const viewer = this.viewers[i];
			if (viewer && viewer.isRemoved && !viewer.pinned) {
				this.viewers.splice(i, 1);
			}
		}
	}
}
